/**
 * FadeImageSlider — custom element.
 *
 * Responsibilities:
 *  1. On init, snap track to the first slide (scrollLeft = 0 centers it via CSS margin).
 *  2. Re-init when Shopify editor reloads the section.
 */

if (!customElements.get('fade-image-slider')) {
  class FadeImageSlider extends HTMLElement {
    connectedCallback() {
      // Let the browser paint first so scroll geometry is ready
      requestAnimationFrame(() => this._init());
    }

    _init() {
      this._track = this.querySelector('.fis__track');
      if (!this._track) return;

      // Ensure we start at the first slide
      this._track.scrollLeft = 0;
    }
  }

  customElements.define('fade-image-slider', FadeImageSlider);
}
